import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const CrmClientsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.crmClientsPage,
      component: React.lazy(() => import('./CrmClientsApp')),
      exact: true,
      auth: authRoles.fullAccess,
    },
  ],
};

export default CrmClientsAppConfig;
